import * as telemetry from '@cian/telemetry/browser';

export function setupDependencies(): void {
  telemetry.setup();
}
